var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0666 32.0005L29.8666 42.6671L46.9333 21.3338M32 61.8671C28.0778 61.8671 24.1941 61.0946 20.5705 59.5937C16.9469 58.0927 13.6544 55.8928 10.881 53.1194C8.10767 50.346 5.90771 47.0535 4.40677 43.4299C2.90583 39.8063 2.1333 35.9226 2.1333 32.0005C2.1333 28.0783 2.90583 24.1946 4.40677 20.571C5.90771 16.9474 8.10767 13.6549 10.881 10.8815C13.6544 8.10816 16.9469 5.90819 20.5705 4.40725C24.1941 2.90631 28.0778 2.13379 32 2.13379C39.9211 2.13379 47.5178 5.28045 53.1189 10.8815C58.72 16.4826 61.8666 24.0793 61.8666 32.0005C61.8666 39.9216 58.72 47.5183 53.1189 53.1194C47.5178 58.7205 39.9211 61.8671 32 61.8671Z",
    stroke: "#41BA5F",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick_circle.051f24d4cafc46f204d99e10928f2dc4.svg";
export { ForwardRef as ReactComponent };